<template>
  <div>
    <a-table bordered
             :rowKey='record => record.children && record.children.length ? record.id : record.id'
            :loading="loading"
            :columns="columns"
            :data-source="menuList"
             :pagination="false"
            @change="handleTableChange"
            >
      <template slot="type" slot-scope="type">
        <a-tag v-if="type == 0" color="#2db7f5" style="width: 72px;height: 24px;line-height: 24px;text-align: center">
          目录
        </a-tag>
        <a-tag v-else-if="type == 1" color="#87d068" style="width: 72px;height: 24px;line-height: 24px;text-align: center">
          菜单
        </a-tag>
        <a-tag v-else-if="type == 2" color="#108ee9" style="width: 72px;height: 24px;line-height: 24px;text-align: center">
          按钮
        </a-tag>
        <a-tag v-else-if="type == 3" color="#01abe9" style="width: 72px;height: 24px;line-height: 24px;text-align: center">
          终端
        </a-tag>
        <a-tag v-else color="#f50"  style="width: 72px;height: 24px;line-height: 24px;text-align: center">
          未知
        </a-tag>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" v-if="hasPerm('/admin/system/menu/findById')" class="margin-right-30" @click="lookMenuInfo(record)">查看</a>
        <a href="javascript:;" v-if="hasPerm('/admin/system/menu/delete')" style="color: #E84D11;" @click="delMenu(record)">删除</a>
      </template>
    </a-table>
    <!-- 删除弹窗 -->
    <a-modal v-model="DELvisible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <a-spin :spinning="DelSpinning">
        <div class="delMenu">
          <div class="DelTitle">删除</div>
          <img src="~@/assets/image/common/DelHint.png" class="delIcon" alt="" />
          <div class="delHint">是否删除{{ DELmenuName }}</div>
          <div class="btn-wrap">
            <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
            <a-button class="confirm" @click="confirm">确定</a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>
    <!-- 查看详情 -->
    <a-modal v-model="menuinfoVisible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
            >
      <a-spin :spinning="infoSpinning">
        <div class="menuInfo-title">菜单详情</div>
        <a-form-model ref="menuInfo" v-bind="layout" :model="menuInfo" :rules="menuInfoFormRules">
          <a-form-model-item has-feedback label="菜单名称" prop="name">
            <a-input v-model="menuInfo.name" type="text" autocomplete="off" :maxLength="150" :disabled="!btnShow"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="父级菜单" prop="parentId">
            <a-tree-select
              :disabled="!btnShow"
              v-model="menuInfo.parentId"
              style="width: 100%"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="MenuTreeData"
              :replaceFields="replaceFields"
              treeNodeFilterProp="title"
              placeholder="请选择父级菜单"
              allow-clear
              searchPlaceholder="请选择父级菜单"
              show-search
              tree-default-expand-all
              value="id"
              title="name"
              key="id"
            >
            </a-tree-select>
          </a-form-model-item>

          <a-form-model-item has-feedback label="类型" prop="type">
<!--            <a-input v-model="menuInfo.type" type="text" autocomplete="off" :maxLength="150" />-->
            <a-radio-group v-model="menuInfo.type" :default-value="1" :disabled="!btnShow">
<!--              <a-radio :value="0">-->
<!--                目录-->
<!--              </a-radio>-->
              <a-radio :value="1">
                菜单
              </a-radio>
              <a-radio :value="2">
                按钮
              </a-radio>
              <a-radio :value="3">
                用户终端权限
              </a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item has-feedback label="菜单路径" prop="url">
            <a-input v-model="menuInfo.url" type="text" autocomplete="off" :maxLength="150"  :disabled="!btnShow"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="请求路径" prop="perms">
            <a-input v-model="menuInfo.perms" type="text" autocomplete="off" :maxLength="150"  :disabled="!btnShow"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="文件路径" prop="path">
            <a-input v-model="menuInfo.path" type="text" autocomplete="off" :maxLength="150" :disabled="!btnShow"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="菜单图标" prop="icon">
            <a-input v-model="menuInfo.icon" type="text" autocomplete="off" :maxLength="150"  :disabled="!btnShow"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="排序" prop="orderNum">
            <a-input-number v-model="menuInfo.orderNum" autocomplete="off" :min="0" :maxLength="11"  :disabled="!btnShow"/>
          </a-form-model-item>
        </a-form-model>

        <div class="menuInfo-btn-wrap">
          <a-button class="btn cancel margin-right-30" @click="MenuInfoCancel">取消</a-button>
          <a-button class="btn btn-active" v-if="!btnShow && hasPerm('/admin/system/menu/save')" @click="MenuInfoEdit">修改</a-button>
          <a-popconfirm
            title="确定提交修改吗？"
            ok-text="提交"
            cancel-text="取消"
            @confirm="confirmEdit('menuInfo')"
          >
            <a-button class="btn btn-active" v-if="btnShow" >提交</a-button>
          </a-popconfirm>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { MenuList, DelMenu, MenuInfo, upDataMenuInfo,MenuNavList } from "api/menu";
import { removeNullChildren } from '@/utils/util'
import search from "@/components/content/search/Search";
import {hasPermission} from "utils/hasPermission";

const columns = [
  {title: "id", align: "left", dataIndex: 'id',key: 'id',width:100},
  {title: "菜单名称", align: "center", dataIndex: 'name',width:200},
  // {title: "父级菜单", align: "center", dataIndex: 'parentId'},
  {title: "类型", align: "center", dataIndex: 'type',width:'100px',scopedSlots: { customRender: 'type' }},
  {title: "菜单URL", align: "center", dataIndex: 'url',ellipsis: true},
  {title: "授权", align: "center", dataIndex: 'perms',ellipsis: true},
  {title: "菜单图标", align: "center", dataIndex: 'icon',width:'100px'},
  {title: "排序", align: "center", dataIndex: 'orderNum',width:'5%',ellipsis: true},
  // {title: "最后修改时间", align: "center", dataIndex: 'lastUpdateTime',ellipsis: true},
  {title: '操作', align: "center", dataIndex: 'operation',width:'150px',scopedSlots: { customRender: 'operation' }}
];

export default {
  name: 'MenuTable',
  components: {
    search
  },
  data() {
    let validateNickname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('菜单名称不能为空'));
      } else {
        callback();
      }
    };
    return {
      columns,
      pagination: {
				defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.pagination.total} 条数据`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },

      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },

      loading: false,
      DelSpinning: false,
      infoSpinning: false,

      pageIndex: 0,
	    pageSize: 10,
      menuName: "",

      menuList: [],

      DELvisible: false,
      DELmenuName: "",
      DELmenuId: Number,

      menuinfoVisible: false,
      menuInfo: {
        id: "",
        createBy: null,
        createTime: null,
        lastUpdateBy: "",
        lastUpdateTime: "",
        parentId: null,
        name: "",
        url: null,
        perms: null,
        path: null,
        type: 0,
        icon: "",
        orderNum: 0,
        delFlag: 0,
        parentName: null,
        level: null,
        children: null,
        ownerId: null
      },

      //父级菜单数据
      MenuTreeData:[],
      //对应自己的后端接口返回字段
      replaceFields: {
        children:'children',//后端数组层级的名字
        key:'id', //一般是id
        value: 'id',//onSelect(selectedKeys)的selectedKeys的参数值，便于获取然后返回给后端
        title: 'name'
      },

      menuInfoFormRules: {
        name: [{ validator: validateNickname, trigger: 'change'}],
      },
      btnShow: false,


    };
  },
  computed: {
    rowSelection() {
      const {selectedRowKeys} = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          this.selectedRowKeys = selectedRowKeys;
          this.objectids = selectedRows.map((item)=>{
            return item.objectid
          })
        },
      };
    },
  },
  mounted() {
    this.getMenuListData()
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    /**
    *逻辑区
    */
    // 表格页面跳转
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.pageIndex = pager.current - 1
      this.getMenuListData()
    },
    // 删除
    delMenu(record) {
      this.DELvisible = !this.DELvisible;
      this.DELmenuName = record.menuName,
      this.DELmenuId = record.id
    },
    // 取消删除
    cancel() {
      this.DELvisible = !this.DELvisible;
    },
    // 查看菜单信息
    lookMenuInfo(record) {
      // this.getMenuInfo(record.id);
      this.menuInfo.id = record.id;
      this.menuInfo.parentId = record.parentId;
      this.menuInfo.name = record.name;
      this.menuInfo.url = record.url;
      this.menuInfo.perms = record.perms;
      this.menuInfo.path = record.path;
      this.menuInfo.type = record.type;
      this.menuInfo.icon = record.icon;
      this.menuInfo.orderNum = record.orderNum;
      this.menuinfoVisible = true;
    },
    // 修改
    MenuInfoEdit() {
      this.btnShow = true
    },
    // 取消
    MenuInfoCancel() {
      this.menuinfoVisible = false;
      this.btnShow = false;
      this.menuInfo = {
        id: "",
        parentId: null,
        name: "",
        url: null,
        perms: null,
        path: null,
        type: 0,
        icon: "",
        orderNum: 0,
      }
    },
    // 确定修改
    confirmEdit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // id,parentId,name,url,perms,path,type,icon,orderNum
          this.setEditMenu(this.menuInfo.id, this.menuInfo.parentId, this.menuInfo.name
            , this.menuInfo.url, this.menuInfo.perms, this.menuInfo.path, this.menuInfo.type, this.menuInfo.icon, this.menuInfo.orderNum
          )
          this.btnShow = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //
    /**
    *逻辑区
    */
    getMenuListData() {
      this.loading = true;
      MenuList()
        .then(res => {
          console.log(res);
          console.log(res.data);
          this.getMenuNavListData()
          if(res.data.length > 0) {
            // let arr = [];
            this.pagination.total = res.totalCount;
            this.menuList = removeNullChildren(res.data);
            console.log('this.menuList',this.menuList)
            this.loading = false;
          } else {
            this.loading = false;
            this.menuList = []
            this.$message.error('没有查询到结果！');
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        })
    },
    getMenuNavListData() {
      MenuNavList()
        .then(res => {
          console.log(res);
          console.log(res.data);
          if(res.data.length > 0) {
            // let arr = [];
            this.MenuTreeData = res.data;
          } else {
            this.menuList = []
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    // 确定删除
    confirm() {
      let that = this
      that.DelSpinning = true
      DelMenu(this.DELmenuId)
        .then(res => {
          console.log(res);
          that.$message.success('删除成功');
          that.getMenuListData();
          that.DelSpinning = false;
          that.DELvisible = false;
        })
        .catch(err => {
          console.log(err);
          that.DelSpinning = false;
          that.DELvisible = false;
          that.$message.error(err.message);
        })
    },
    // 查询菜单信息
    getMenuInfo(id) {
      this.infoSpinning = true;
      MenuInfo(id)
        .then(res => {
          this.infoSpinning = false;
          console.log(res);
          const data = res.data;
          this.menuInfo.id = data.id;
          this.menuInfo.name = data.name;
          this.menuInfo.remark = data.remark;
        })
        .catch(err => {
          this.infoSpinning = false;
          console.log(err);
        })
    },
    // 修改菜单信息
    setEditMenu(id,parentId,name,url,perms,path,type,icon,orderNum) {
      console.log(111);
      this.DelSpinning = true;
      upDataMenuInfo(id,parentId,name,url,perms,path,type,icon,orderNum)
        .then(res => {
          this.DelSpinning = false;
          console.log(res);
          this.$message.success('修改成功');
          this.menuinfoVisible = false
          this.getMenuListData();
        })
        .catch(err => {
          this.DelSpinning = false;
          console.log(err);
          this.$message.error('请重试,修改失败');
        })
    },
    //数字格式化
    IntToFloat(fee) {
      return parseFloat(fee).toFixed(2);
    },
  }
}
</script>

<style  lang='scss' scoped>
::v-deep .ant-table {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

::v-deep .ant-table-container,
::v-deep .ant-table-content,
::v-deep .ant-table-body,
::v-deep .ant-table-placeholder {
  background: #fff !important;
}

::v-deep .ant-table-thead > tr > th {
  background: #33CCE0 !important;
  color: #fff !important;
  font-weight: 600;
  border-color: #7fddec !important;
}

::v-deep .ant-table-tbody > tr > td {
  background: #fff !important;
}

::v-deep .ant-table-tbody > tr:hover > td {
  background: #e6f9fc !important;
}

::v-deep .ant-table-tbody > tr.ant-table-row-selected > td {
  background: #ccf3f8 !important;
}

::v-deep .ant-table-bordered .ant-table-body > table,
::v-deep .ant-table-bordered .ant-table-fixed-left table,
::v-deep .ant-table-bordered .ant-table-fixed-right table {
  border-color: #7fddec !important;
}

::v-deep .ant-table-bordered .ant-table-thead > tr > th,
::v-deep .ant-table-bordered .ant-table-tbody > tr > td {
  border-color: #b3eaf3 !important;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active {
  border-color: #33CCE0;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active a {
  color: #33CCE0;
}

::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link {
  color: #33CCE0;
  border-color: #33CCE0;
}

.delMenu {
  text-align: center;
  .DelTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .delIcon {
    display: inline-block;
    width: 196px;
    height: 160px;
  }
  .delHint {
    color: #212121;
    font-size: 36px;
    line-height: 90px;
  }
  .btn-wrap {
    text-align: center;
    .confirm {
      color: #fff;
      background-color: #33CCE0;
    }
  }
}
.menuInfo-title {
  line-height: 10px;
  font-size: 22px;
  text-align: center;
  margin-bottom: 15px;
}
.menuInfo-btn-wrap {
  text-align: center;
  margin-top: 15px;
  .btn-active {
    background-color: #33CCE0;
    color: #fff;
  }
}
</style>
